import axios from '../../axios'

/*
 * 材料数据接口
 */
// 获取材料数据分页列表
export const getmaterialpageList = (data) => {
    return axios({
        url: '/api/course/tiktok/material/page',
        method: 'get',
        data
    })
}

// 材料id查询
export const getIdmaterialpageList = (data) => {
    return axios({
        url: '/api/course/tiktok/material/get',
        method: 'get',
        data
    })
}

// 材料上传
export const uploadmaterialpageList = (data) => {
    return axios({
        url: '/api/course/tiktok/material/upload',
        method: 'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/tiktok/material.js